.main {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
}

.selector {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: var(--size-3);
	font-weight: 500;

	.button {
		display: flex;
		font-weight: 600;
		padding: 0 var(--size-3);
		gap: var(--size-2);
		text-transform: capitalize;

		&:hover,
		&:focus-visible {
			background-color: var(--color-surface-hover);
		}
		transition: background-color 0.1s ease;
	}

	&:has(:popover-open) .arrow {
		transform: rotate(180deg);
	}

	.arrow {
		transform-origin: center center;
		transition: transform 0.1s ease;
	}
}

.passkeyCallout {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: var(--text-body);
	padding: var(--size-3) var(--size-5);
	border-radius: var(--radius-lg);
	border: var(--size-border) solid var(--color-border);
	background-color: var(--color-surface-hover);
	color: var(--color-text-secondary);
}
